"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setImagesSlider = exports.setFavoriteProduct = exports.setLayoutType = exports.changeDefaultImage = exports.setRelatedProducts = exports.setActiveProduct = exports.setRelatedAccessories = exports.openFilters = exports.setPimConfig = exports.setPepDictionary = exports.setPepFilters = exports.setActiveProducts = exports.setSelectedFilters = exports.setProductList = void 0;

var _actions = require("./actions");

var setProductList = function setProductList(pimData) {
  return {
    type: _actions.SET_PRODUCT_LIST,
    productList: pimData
  };
};

exports.setProductList = setProductList;

var setSelectedFilters = function setSelectedFilters(filters) {
  return {
    type: _actions.SELECTED_FILTERS,
    selectedFilters: filters
  };
};

exports.setSelectedFilters = setSelectedFilters;

var setActiveProducts = function setActiveProducts(products) {
  return {
    type: _actions.SET_ACTIVE_PRODUCTS,
    activeProducts: products
  };
};

exports.setActiveProducts = setActiveProducts;

var setPepFilters = function setPepFilters(pepFilters) {
  return {
    type: _actions.SET_PEP_FILTERS,
    pepFilters: pepFilters
  };
};

exports.setPepFilters = setPepFilters;

var setPepDictionary = function setPepDictionary(dictionary) {
  return {
    type: _actions.SET_PEP_DICTIONARY,
    dictionary: dictionary
  };
};

exports.setPepDictionary = setPepDictionary;

var setPimConfig = function setPimConfig(pimConfig) {
  return {
    type: _actions.SET_PIM_CONFIG,
    pimConfig: pimConfig
  };
};

exports.setPimConfig = setPimConfig;

var openFilters = function openFilters(isOpen) {
  return {
    type: _actions.OPEN_FILTERS,
    openFilters: isOpen
  };
};

exports.openFilters = openFilters;

var setRelatedAccessories = function setRelatedAccessories(related) {
  return {
    type: _actions.SET_RELATED_ACCESSORIES,
    relatedAccessories: related
  };
};

exports.setRelatedAccessories = setRelatedAccessories;

var setActiveProduct = function setActiveProduct(product) {
  return {
    type: _actions.SET_SELECTED_PRODUCT,
    selectedProduct: product
  };
};

exports.setActiveProduct = setActiveProduct;

var setRelatedProducts = function setRelatedProducts(products) {
  return {
    type: _actions.SET_RELATED_PRODUCTS,
    relatedProducts: products
  };
};

exports.setRelatedProducts = setRelatedProducts;

var changeDefaultImage = function changeDefaultImage(url) {
  return {
    type: _actions.CHANGE_DEFAULT_IMAGE,
    url: url
  };
};

exports.changeDefaultImage = changeDefaultImage;

var setLayoutType = function setLayoutType(isMobile) {
  return {
    type: _actions.SET_LAYOUT_TYPE,
    isMobile: isMobile
  };
};

exports.setLayoutType = setLayoutType;

var setFavoriteProduct = function setFavoriteProduct(products) {
  return {
    type: _actions.SET_FAVORITE_PRODUCT,
    favoriteProducts: products
  };
};

exports.setFavoriteProduct = setFavoriteProduct;

var setImagesSlider = function setImagesSlider(images) {
  return {
    type: _actions.SET_IMAGE_SLIDER,
    currentSliderImg: images
  };
};

exports.setImagesSlider = setImagesSlider;